import {  RdrTransferForm } from "../../components-rdr";
import { RedirectSelects } from "../../components-integrity";


export const RDRTransferModule = () => {
  RedirectSelects();
  return (
    <>
      <RdrTransferForm />
    </>
  );
};

